import PropTypes from 'prop-types'
import styles from './MediosDePago.module.css'

const MERCADO_PAGO = 7

const Medios = ({ data, titulo }) => {
  return (
    <div className={`row ${styles.mediosPagoWrapper}`}>
      <div className="col">
        <p className={styles.tituloDetalle}>{titulo}</p>

        <div className={styles.listaMedios}>
          {data?.map((item) => {
            const idItem = item.idMedioPago || item.idMedioEnvio
            return (
              <span
                key={`${item.icono}-${idItem}`}
                className={styles.chipMedio}
                {...(item.idMedioPago === MERCADO_PAGO && { title: item.descripcion })}
              >
                {item.nombre}
              </span>
            )
          })}
        </div>
      </div>
    </div>
  )
}

Medios.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      icono: PropTypes.string,
      idMedioPago: PropTypes.number,
      idMedioEnvio: PropTypes.number,
      nombre: PropTypes.string,
      descripcion: PropTypes.string
    })
  ).isRequired,
  titulo: PropTypes.string.isRequired
}

export default Medios
